import { SeasonStats } from '../types';

interface Props {
  stats: SeasonStats;
  strongCount: number;
  isLive: boolean;
}

function Pill({
  label, color, bg
}: { label: string; color: string; bg: string }) {
  return (
    <span style={{
      padding: '5px 12px',
      borderRadius: 20,
      fontSize: '0.7rem',
      fontWeight: 600,
      background: bg,
      color,
      whiteSpace: 'nowrap',
    }}>
      {label}
    </span>
  );
}

export default function HeroBanner({ stats, strongCount, isLive }: Props) {
  const today = new Date().toLocaleDateString('en-US', {
    weekday: 'long',
    month: 'long',
    day: 'numeric',
    year: 'numeric',
  });

  return (
    <div style={{
      padding: '20px 20px 16px',
      borderBottom: '1px solid #E4EAF8',
    }}>

      {/* DATE */}
      <div style={{
        fontSize: '0.62rem',
        fontWeight: 700,
        letterSpacing: 3,
        textTransform: 'uppercase',
        color: '#8090B0',
        marginBottom: 6,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
      }}>
        <span>{today}</span>
        {isLive && (
          <span style={{
            fontSize: '0.58rem',
            fontWeight: 700,
            color: '#15803D',
            letterSpacing: 1.5,
            display: 'flex',
            alignItems: 'center',
            gap: 4,
          }}>
            <span style={{
              width: 5, height: 5,
              background: '#15803D',
              borderRadius: '50%',
              display: 'inline-block',
              animation: 'livePulse 2s ease infinite',
            }} />
            LIVE DATA
          </span>
        )}
      </div>

      {/* HEADLINE */}
      <div style={{
        fontSize: '1.85rem',
        fontWeight: 800,
        lineHeight: 1.05,
        letterSpacing: '-0.5px',
        color: '#0A1740',
      }}>
        Zero Home Run<br />
        <span style={{ color: '#D42B2B' }}>Probability</span> Tracker
      </div>

      {/* PILLS */}
      <div style={{
        display: 'flex',
        gap: 8,
        marginTop: 14,
        flexWrap: 'wrap',
      }}>
        <Pill
          label={`${strongCount} Strong Plays`}
          color="#15803D"
          bg="#DCFCE7"
        />
        <Pill
          label={`${stats.rate}% Season Rate`}
          color="#1535A0"
          bg="#F0F3FF"
        />
        <Pill
          label={`${stats.accuracy}% Accuracy`}
          color="#0A1740"
          bg="#F5F6FA"
        />
      </div>

    </div>
  );
}
